<script>
import { BDropdownItemButton } from "bootstrap-vue";

export default {
  extends: BDropdownItemButton
};
</script>